import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const CustomTheme = definePreset(Aura, {
  primitive: {},
  semantic: {},
});

export default CustomTheme;
